import { useMemo, useState, useEffect } from 'react';
import cx from 'classnames';
import { icons } from '../assets';
import { emailIsValid, generateUUID } from '../helpers/jsHelper';

const { WarningIcon, RoundcloseIcon } = icons;

function createEmailTag(data) {
  let tagData = {
    id: generateUUID(),
    name: data.email,
    warning: !emailIsValid(data.email),
  };

  return tagData;
}

const TagInputField = (props) => {
  // const inputRef = useRef();

  const [input, setInput] = useState('');
  const [tags, setTags] = useState(props?.tags || []);

  const fieldKey = useMemo(() => props?.keyName || 'email', [props?.keyName]);
  const createTag = useMemo(() => props?.createTag || createEmailTag, [props?.createTag]);

  useEffect(() => {
    setTags(props?.tags || []);
  }, [props?.tags]);

  // useEffect(() => inputRef.current.focus() , [])

  function handleInputChange(e) {
    setInput(e.target.value);
  }

  function onEnterPress(e) {
    const { key: eventKey } = e;

    if (eventKey === 'Enter' || eventKey === ',') {
      e.preventDefault();

      const trimmedInput = input.trim();

      if (trimmedInput === '') {
        return;
      }

      if (tags.some((tag) => tag.name === trimmedInput)) {
        setInput('');
        return;
      }

      // Check max tags limit before adding
      if (props?.maxTags && tags.length >= props.maxTags) {
        props?.onMaxTagsCallback?.();
        setInput('');
        return;
      }

      const tagPayload = { [fieldKey]: trimmedInput };
      let newTagList = [...tags, createTag(tagPayload)];

      setTags(newTagList);
      setInput('');
      props.setData(newTagList);
    }
  }

  function onBlur(e) {
    e.preventDefault();
    let trimmedInput = input.trim();
    if (trimmedInput.length === 0) return;

    if (tags.some((tag) => tag.name === trimmedInput)) {
      setInput('');
      return;
    }

    // Check max tags limit before adding
    if (props?.maxTags && tags.length >= props.maxTags) {
      props?.onMaxTagsCallback?.();
      setInput('');
      return;
    }

    const tagPayload = { [fieldKey]: trimmedInput };
    let newTagList = [...tags, createTag(tagPayload)];

    setTags(newTagList);
    setInput('');
    props.setData(newTagList);

    props?.validateForm?.(newTagList);
  }

  function removeTagFromList(tag) {
    let newTagList = tags.filter((t) => t.id !== tag.id);

    setTags(newTagList);
    props.setData(newTagList);

    props?.validateForm?.(newTagList);

    if (!newTagList.length) {
      props?.setErrors?.({});
      // inputRef.current.focus();
    }
  }

  useEffect(() => {
    if (input !== '') {
      props?.setErrors?.((prevState) => ({ ...prevState, [fieldKey]: '' }));
    }
    // Only re-run when input or fieldKey change to avoid render loops
  }, [input, fieldKey]);

  return (
    <div
      className={cx(
        'tags-container',
        props.className,
        (input !== '' || tags.length) && 'active',
        props?.icon ? 'has-icon' : ''
      )}
      style={props.customStyle || {}}>
      {tags?.length === 0 && props?.icon ? props?.icon : null}
      {tags.map((tag) => (
        <span key={tag.id} className={cx('tag', tag.warning && 'text-danger')}>
          {tag.warning && <WarningIcon />}
          <span className="tag-label">{tag.name}</span>
          <span className="tag-close-icon" onClick={() => removeTagFromList(tag)}>
            <RoundcloseIcon />
          </span>
        </span>
      ))}
      {input === '' &&
        !tags?.length && ( //!inputRef.current
          <span
            className="inputLabel"
            style={{
              position: 'absolute',
              color: props.className ? '#e4291d' : '#5A5C61',
              zIndex: '8',
            }}>
            {props?.inputLabel || 'Type Invitee email'}
          </span>
        )}
      <input
        // ref={inputRef}
        className={cx(props.className)}
        // placeholder={
        //   !tags?.length ? 'Type Invitee email (Hit enter for adding multiple emails)' : ''
        // }
        value={input}
        onChange={handleInputChange}
        onKeyDown={onEnterPress}
        onBlur={onBlur}
        // autoFocus
      />
    </div>
  );
};

export default TagInputField;
